export function BtnFilter(props) {
  const {
    handlerOnClick,
    isClose = true,
    disabled,
    label,
    resetLabel,
    className = '',
    showReset = true
  } = props
  return (
    <div className={`d-flex ${className}`}>
      <button
        disabled={disabled}
        type="button"
        className={`btn ${isClose ? 'btn-outline-primary' : 'btn-outline-danger'}`}
        onClick={() => handlerOnClick()}>
        <i className={`${isClose ? 'star-icon-search' : 'star-icon-cancel'} star-icon me-2`} />
        {isClose ? label : resetLabel}
      </button>
    </div>
  )
}
